import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_BO_DEMO_ILO1 = {
  title:
    "End-to-end order visibility, \nfeaturing complex order \nvisualization",
  subtitle: "Business Operations Demo",
  text: "Single view of KPIs and OKRs resulting in CSR \ndelights and operations delights.",
  label: { iconPath: "start.png", text: "EPV" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_110"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_108"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO1/ILO1_demo_screens_base.png",
  rightSideVideo: "ILO/ILO1/INF_CMT_827.23_Business Demo_Part 6_R1.mp4",
  pageNumber: "ILO_109",
};

export default DATA_BO_DEMO_ILO1;
